export default "__VITE_ASSET__BmpXc7e___"